const Dashboard = () => import("./dashboard/views/Dashboard.vue");
import appraisalRoutes from "./appraisal/routes";
import feedbackRoutes from "./feedback/routes";
import ReportRoutes from "./report/routes";
import TrainingRoutes from "./training/routes";
import TaskManagementRoutes from "./taskManagement/routes";

export default [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "appraisal",
    redirect: "/admin/performance/appraisal/appraisal-group",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: appraisalRoutes,
  },
  {
    path: "feedback",
    redirect: "/admin/performance/feedback/view-all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: feedbackRoutes,
  },
  {
    path: "report",
    redirect: "/admin/performance/report/generate",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: ReportRoutes,
  },
  {
    path: "task-management",
    redirect: "/admin/performance/task-management/task-board",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: TaskManagementRoutes,
  },
  {
    path: "training",
    redirect: "/admin/performance/training/general-training",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: TrainingRoutes,
  },
];
